export const HEIGHT_OF_OPERATORITEM_IN_REM: number = 3.5;
export const HEIGHT_OF_NO_OPERATORS_DIV_IN_REM: number = 3;
export const HEIGHT_OF_DROPDOWN_HEADER_IN_REM: number = 3;
export const HEIGHT_OF_LOADER_IN_REM: number = 2;

export const INPUT_LINES_COUNT: number = 10;

export const INPUT_SYMBOLS_COUNT: number = 2000;